import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../App';
import { t } from '../../i18n';
import { Lock } from 'lucide-react';

export default function UpgradePrompt({ show, onClose, feature, requiredPlan }) {
  const navigate = useNavigate();
  const { language } = useLanguage();

  if (!show) return null;

  return (
    <div className="upgrade-overlay" onClick={onClose}>
      <div className="upgrade-card" onClick={e => e.stopPropagation()}>
        <div className="upgrade-icon"><Lock size={32} /></div>
        <h3 className="upgrade-title">{t('upgradeRequired', language)}</h3>
        <p className="upgrade-desc">
          {t('upgradeDesc', language).replace('{feature}', feature || '').replace('{plan}', (requiredPlan || 'Basic').toUpperCase())}
        </p>
        <div className="upgrade-actions">
          <button className="upgrade-btn-primary" onClick={() => { onClose(); navigate('/pricing'); }}>
            {t('viewPlans', language)}
          </button>
          <button className="upgrade-btn-secondary" onClick={onClose}>
            {t('maybeLater', language)}
          </button>
        </div>
      </div>
    </div>
  );
}
